"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ViewRowColorController", {
    enumerable: true,
    get: function() {
        return ViewRowColorController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _viewrowcolorservice = require("~/services/view-row-color.service");
const _globalguard = require("~/guards/global/global.guard");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ViewRowColorController = class ViewRowColorController {
    async setViewRowColorSelect(context, viewId, body) {
        return await this.viewRowColorService.setRowColoringSelect(_extends({}, body, {
            fk_view_id: viewId,
            context
        }));
    }
    async addViewRowColorCondition(context, viewId, body) {
        return await this.viewRowColorService.addRowColoringCondition(_extends({}, body, {
            fk_view_id: viewId,
            context
        }));
    }
    async updateViewRowColorCondition(context, viewId, id, body) {
        return await this.viewRowColorService.updateRowColoringCondition(_extends({}, body, {
            context,
            fk_view_id: viewId,
            fk_row_coloring_conditions_id: id
        }));
    }
    async deleteViewRowColorCondition(context, viewId, id) {
        return await this.viewRowColorService.deleteRowColoringCondition({
            context,
            fk_view_id: viewId,
            fk_row_coloring_conditions_id: id
        });
    }
    constructor(viewRowColorService){
        this.viewRowColorService = viewRowColorService;
    }
};
_ts_decorate([
    (0, _common.Post)('/row-color-select'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('viewRowColorSelectAdd'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcContext === "undefined" ? Object : _nocodbsdk.NcContext,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewRowColorController.prototype, "setViewRowColorSelect", null);
_ts_decorate([
    (0, _common.Post)('/row-color-conditions'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('viewRowColorConditionAdd'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcContext === "undefined" ? Object : _nocodbsdk.NcContext,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewRowColorController.prototype, "addViewRowColorCondition", null);
_ts_decorate([
    (0, _common.Patch)('/row-color-conditions/:id'),
    (0, _extractidsmiddleware.Acl)('viewRowColorConditionUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Param)('id')),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcContext === "undefined" ? Object : _nocodbsdk.NcContext,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewRowColorController.prototype, "updateViewRowColorCondition", null);
_ts_decorate([
    (0, _common.Delete)('/row-color-conditions/:id'),
    (0, _extractidsmiddleware.Acl)('viewRowColorConditionDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Param)('id')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcContext === "undefined" ? Object : _nocodbsdk.NcContext,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewRowColorController.prototype, "deleteViewRowColorCondition", null);
ViewRowColorController = _ts_decorate([
    (0, _common.Controller)('/api/v1/db/meta/views/:viewId'),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _viewrowcolorservice.ViewRowColorService === "undefined" ? Object : _viewrowcolorservice.ViewRowColorService
    ])
], ViewRowColorController);
